import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Field, initialize } from 'redux-form';
import { push } from 'connected-react-router';
import ActionButton from 'jbc-front/components/ActionButton'
import { renderInlineDatePickerField } from 'src/jbc-front/components/Form';
import * as validators from 'jbc-front/utils/validators';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import styles from './AuditLogsDateRangeForm.scss';

const DEFAULT_SEARCH = {
  start_date: '',
  end_date: ''
};

const OMIT_FIELDS = ['page', 'per_page'];

const dateRangeFormValidate = (value, values) => {
  if (_.isEmpty(values.startDate)) {
    return validators.date(value);
  }
  let errorMessage;
  [validators.required, validators.date].some(func => {
    errorMessage = func(value);
    return errorMessage !== undefined;
  });
  return errorMessage;
};

const dateFieldProps = {
  normalize: value => (_.isObject(value) && value.format ? value.format('DD/MM/YYYY') : value || ''),
  format: value => (_.isString(value) ? value.replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, '$3/$2/$1') : value || ''),
  validate: validators.date
};

const AuditLogsDateRangeForm = (props) => {
  const { handleClear,location } = props
  const { t } = useTranslation();
  const omitedSearch = _.omit(queryString.parse(location.search), OMIT_FIELDS);
  const isSearchParamsBlank = location.search === '';
  const isSearchParamsEqualDefaultCondition = _.isEqual(omitedSearch, DEFAULT_SEARCH);

  return (
    <div className="u-mb20">
      <div className={styles.mainSearchFields}>
        <div className={styles.mainFormControls}>
          <div className={styles.mainFormControl}>
            <div className={styles.dateFields}>
                <Field
                  component={renderInlineDatePickerField}
                  type="text"
                  name="startDate"
                  width={190}
                  validate={dateRangeFormValidate}
                  {...dateFieldProps}
                />
                &nbsp;〜&nbsp;
                <Field
                  component={renderInlineDatePickerField}
                  type="text"
                  name="endDate"
                  width={190}
                  validate={dateRangeFormValidate}
                  {...dateFieldProps}
                />
            </div>
          </div>
          <ActionButton
            primary={!isSearchParamsBlank && !isSearchParamsEqualDefaultCondition}
            as="button"
            type="button"
            className={styles.mainFormControl}
            onClick={handleClear}
          >
            {t('jbc-front.components.SearchForm.Deslect_conditions')}
          </ActionButton>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  location: state.router.location
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleClear: location => {
    const { formName, resetValues } = ownProps;
    dispatch(initialize(formName, resetValues));
    dispatch(push({ ...location, search: '' }));
  }
});

export default connect(mapStateToProps,mapDispatchToProps)(AuditLogsDateRangeForm);
